import { isString } from './boolean';

/**
 * Removes the HTML tags from given string
 *
 * @param {string} str
 *
 * @return {string}
 */
export var stripTags = function stripTags(str) {
  return str.replace(/(<([^>]+)>)/gi, '');
};

/**
 * Removes all non numeric chars from provided string.
 *
 * @param {string} str
 *
 * @return {string}
 */
export var stripNonNumeric = function stripNonNumeric(str) {
  if (str && isString(str)) {
    return str.replace(/\D/g, '');
  }
  return '';
};

/**
 * Converts provided value to string
 *
 * @param {mixed}
 *
 * @return {string}
 */
export var toString = function toString(val) {
  return String(val);
};

/**
 * Pads the current string with another string (multiple times, if needed) until
 * the resulting string reaches the given length.
 *
 * @param {string} str
 * @param {number} targetLength
 * @param {string} padString
 *
 * @return {string}
 */
export var strPadStart = function strPadStart(str, targetLength, padString) {
  if (padString === void 0) {
    padString = '';
  }
  return toString(str).padStart(targetLength, padString);
};